export function LockupContainer(props) {
  return (
    <>
      <div className="large_lockup_container">
        <div
          style={{
            fontSize: props.fontSize + "rem",
            opacity: props.opacity,
            cursor: "default",
          }}
        >
          {props.title}
        </div>
        <p>{props.copy}</p>
        {props.children}
      </div>
    </>
  );
}
